import { Component, OnInit, Input } from "@angular/core";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { InvoiceService } from "./../../../_services/invoice.service";

@Component({
    selector: "app-invoice-submission",
    templateUrl: "./invoice-submission.component.html",
    styleUrls: ["./invoice-submission.component.scss"],
})
export class InvoiceSubmissionComponent implements OnInit {
    invoiceTypes = [
        { label: "IRN e-invoice", type: "e-invoice" },
        { label: "Digitally Signed e-invoice", type: "ds-invoice" },
    ];
    supportingDocuments: any[] = [];
    loading = false;
    fileTypeError = false;
    fileSizeError = false;
    signatureError = false;
    qrCodeError = false;
    validateSignature = false;
    validateEinvoice = false;
    validateEinvoiceResubmit = false;
    responseData: any;
    displayName: any;
    message: any;
    poItems = [];
    fileName: string = "";
    poNo: any;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    dsLoaderMsg = "";
    eLoaderMsg = "";
    eLoaderMsgResubmit = "";
    timeoutID;
    formSubmitted = false;
    previousUrl: any;
    totalSizeError;
    files: File[];

    invoiceData = new FormGroup({
        invoiceType: new FormControl(null, [Validators.required]),
        file: new FormControl(null),
        fileSource: new FormControl(null, [Validators.required]),
    });

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.previousUrl =
            this.route.snapshot.queryParams["returnUrl"] || "dashboard";
        //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
        console.log(this.previousUrl);
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    selectInvoice(event: any) {
        this.invoiceService.setFileElement(event[0]);

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

        if (event.length > 0) {
            const fileUploaded = event[0];
            if (fileUploaded.type !== "application/pdf") {
                this.fileTypeError = true;
            } else if (fileUploaded.size > MAX_FILE_SIZE) {
                this.fileSizeError = true;
            } else {
                this.invoiceData.patchValue({
                    fileSource: fileUploaded,
                });
            }
        }

        this.fileName = event[0].name;
    }

    extrationMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsg = msg;
        }, time);
    }

    extrationResubmitMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsgResubmit = msg;
        }, time);
    }

    onInvoiceSubmit() {
        this.loading = true;
        this.formSubmitted = true;

        this.invoiceService.setDocuments(this.supportingDocuments);

        //console.log(convertPods);
        const pods: any = localStorage.getItem("pods");
        const convertPods = JSON.parse(pods);
        const poItems: any = [];
        //console.log(convertPods);
        convertPods.forEach((p: any) => {
            if (p.grn_no !== "" || typeof p.grn_no !== "undefined") {
                poItems.push({
                    poNumber: p.po_no,
                    itemNo: p.po_item_line,
                    grn: p._id,
                });
            } else {
                poItems.push({
                    poNumber: p.po_no,
                    itemNo: p.po_item_line,
                    grn: "",
                });
            }
        });

        let companyCode = "";
        let purchaseOrg = "";
        let docType = "";
        if (convertPods[0].grn_no !== "") {
            companyCode = convertPods[0].po_company_code;
            purchaseOrg = convertPods[0].po_purchase_org;
            docType = convertPods[0].po_doc_type;
            //console.log("material");
        } else {
            companyCode = localStorage.getItem("servCompanyCode");
            purchaseOrg = localStorage.getItem("servPurchaseOrg");
            docType = localStorage.getItem("servDocType");
            //console.log("service");
        }

        const userData = {
            req: {
                companyCode: companyCode,
                purchaseOrg: purchaseOrg,
                docType: docType,
                items: poItems,
            },
        };

        if (this.invoiceData.value.invoiceType === "e-invoice") {
            this.validateEinvoice = true;
            this.invoiceService.setInvoiceType("po_based");
            this.invoiceService.setInvType("e-invoice");

            const formData: any = new FormData();
            formData.append("poNumber", this.route.snapshot.params["poNo"]);
            formData.append("sellerCode", localStorage.getItem("vendorCode"));
            formData.append("sessionId", localStorage.getItem("userSession"));
            formData.append("invoiceType", "po_based");
            formData.append("invType", this.invoiceData.value.invoiceType);
            formData.append("req", JSON.stringify(userData.req));
            formData.append("file", this.invoiceData.value.fileSource);
            formData.append("extractionVersion", "1");

            this.eLoaderMsg = "Verifying QR Code";

            setTimeout(() => {
                this.dsLoaderMsg = "Authenticating QR Code";
            }, 5000);
            setTimeout(() => {
                this.dsLoaderMsg = "Extracting Data";
            }, 10000);
            setTimeout(() => {
                this.dsLoaderMsg = "Validating Data";
            }, 15000);

            this.invoiceService.extractInvoice(formData).subscribe(
                (res) => {
                    this.loading = false;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.responseData = res;
                    clearTimeout(this.timeoutID);
                    //console.log(res);
                    if (
                        this.responseData.length !== 0 &&
                        this.responseData.status === "error"
                    ) {
                        console.log("error");
                        //console.log(this.responseData);

                        //this.qrCodeError = true;

                        //this.message = this.responseData.msg;

                        if (this.responseData.msg.includes("unreadable")) {
                            this.loading = true;
                            this.validateEinvoiceResubmit = true;

                            this.eLoaderMsgResubmit =
                                "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

                            formData.set("extractionVersion", "2");
                            //this.eLoaderMsg = "Authenticating QR Code";

                            this.extrationResubmitMessages(
                                "Verifying QR Code",
                                5000
                            );
                            this.extrationResubmitMessages(
                                "Authenticating QR Code",
                                10000
                            );
                            this.extrationResubmitMessages(
                                "Extracting Data",
                                15000
                            );
                            this.extrationResubmitMessages(
                                "Validating Data",
                                20000
                            );

                            setTimeout(() => {
                                this.invoiceService
                                    .reExtractInvoice(formData)
                                    .subscribe(
                                        (res) => {
                                            this.responseData = res;

                                            if (
                                                this.responseData.length !==
                                                    0 &&
                                                this.responseData.status ===
                                                    "error"
                                            ) {
                                                this.validateEinvoiceResubmit =
                                                    false;
                                                this.qrCodeError = true;
                                                this.message =
                                                    this.responseData.msg;
                                            } else {
                                                this.qrCodeError = false;
                                                this.poNo =
                                                    this.route.snapshot.params[
                                                        "poNo"
                                                    ];
                                                this.invoiceService.setProcessedInvoice(
                                                    this.responseData
                                                );
                                                this.router.navigate([
                                                    "/invoice-preview",
                                                    this.poNo,
                                                ]);
                                            }
                                        },
                                        (error) => {
                                            this.validateEinvoiceResubmit =
                                                    false;
                                                this.qrCodeError = true;
                                                this.message =
                                                    this.responseData.msg;
                                        }
                                    ),error => {
                                        this.validateEinvoiceResubmit =
                                                    false;
                                                this.qrCodeError = true;
                                                this.message =
                                                    this.responseData.msg;
                                    }
                            }, 22000);
                        }
                    } else {
                        //console.log(this.responseData);
                        this.qrCodeError = false;
                        this.poNo = this.route.snapshot.params["poNo"];
                        this.invoiceService.setProcessedInvoice(
                            this.responseData
                        );
                        //this.invoiceService.setInvoiceType();
                        //localStorage.setItem('invoice', JSON.stringify(this.responseData));
                        this.router.navigate(["/invoice-preview", this.poNo]);
                    }
                },
                (error) => {
                    console.log(error);
                    this.validateEinvoiceResubmit =
                                                    false;
                                                this.loading = true;
                                                this.validateEinvoice = false;
                                                this.qrCodeError = true;
                                                this.message = "We couldn't extract the invoice details due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
                }
            );
        } else {
            this.validateSignature = true;
            this.invoiceService.setInvoiceType("po_based");
            this.invoiceService.setInvType("ds-invoice");
            const formData: any = new FormData();
            formData.append("sellerCode", localStorage.getItem("vendorCode"));
            formData.append("sessionId", localStorage.getItem("userSession"));
            formData.append("invoiceFile", this.invoiceData.value.fileSource);
            formData.append("invoiceType", "po_based");
            formData.append("invType", this.invoiceData.value.invoiceType);

            this.dsLoaderMsg = "Verifying Signature";

            setTimeout(() => {
                this.dsLoaderMsg = "Authenticating Signature";
            }, 5000);
            setTimeout(() => {
                this.dsLoaderMsg = "Extracting Data";
            }, 10000);
            setTimeout(() => {
                this.dsLoaderMsg = "Validating Data";
            }, 15000);

            this.invoiceService.verifyDigitalSignature(formData).subscribe(
                (res) => {
                    this.loading = false;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.responseData = res;
                    //console.log(res);
                    if (
                        this.responseData.length !== 0 &&
                        this.responseData.status === "error"
                    ) {
                        this.loading = true;
                        this.signatureError = true;
                        this.message = this.responseData.msg;
                    } else {
                        this.qrCodeError = false;
                        this.poNo = this.route.snapshot.params["poNo"];
                        this.invoiceService.setFileUrl(
                            this.responseData.file_link
                        );
                        this.invoiceService.setDataDigitalInvoice(
                            this.responseData.data
                        );
                        //localStorage.setItem('invoice', JSON.stringify(this.responseData));
                        this.router.navigate([
                            "/invoice-preview-digital-invoice",
                            this.poNo,
                        ]);
                    }
                },
                (error) => {
                    this.loading = true;
                    this.validateSignature = false;
                    this.signatureError = true;
                    this.message = "We couldn't verify the signature due to a temporary issue.Please try again in a few moments. If the problem continues, contact support."
                }
            );
        }
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.formSubmitted = false;
    }

    closeFileErrorDialog() {
        this.loading = false;
        this.fileTypeError = false;
        this.qrCodeError = false;
    }

    closeSignatureErrorDialog() {
        this.loading = false;
        this.signatureError = false;
    }
}
